var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4.04687L4.04687 0L18.5 14.4531L32.9531 0L37 4.04687L22.5469 18.5L37 32.9531L32.9531 37L18.5 22.5469L4.04687 37L0 32.9531L14.4531 18.5L0 4.04687Z","fill":"#FBEF89"}));
}

Exit.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = Exit;

Exit.default = Exit;
